import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TransformerManagerService } from '../services/transformerManager.service';
import { DeviceMasterService } from '../services/device-master.service';
import { EmsdashboardService } from '../services/emsdashboard.service';
import { CustomDateComponent } from '../reports/customdate/custom-date.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatPaginator, MatSort,  MatDialog, MatDialogConfig } from '@angular/material'
import { DateTime } from '@syncfusion/ej2-angular-charts';
import { debounce } from 'lodash'; // Import debounce function from lodash
import { DatePipe } from '@angular/common'; // Import the DatePipe


@Component({
  selector: 'app-ems-individual-dashboard',
  templateUrl: './ems-individual-dashboard.component.html',
  styleUrls: ['./ems-individual-dashboard.component.scss']
})

export class EmsIndividualDashboardComponent implements OnInit {


  @ViewChild('energyconsumption_graph', { static: true }) energyconsumption_graph: ElementRef;

  @ViewChild('individual_graph', { static: true }) individual_graph: ElementRef;
  @ViewChild('chart2', { static: true }) chart: ElementRef;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;


  myData: any = [ ];

  heading_dummy_alert: string[] = ['startTime', 'type', 'threshold', 'actual'];
lastfives;
count_m=1;
graphData;
countstepno;
kvar_meter;
lastmeter;
  meterno = "1";
  AllEnergyMeterData;
  Deviceid;
  uniqueDeviceId;
  selectedDevice;
  energyMeterId = [];
 systemkvahf: any = 0;
systemkvahl: any = 0;
  energyMeterIdArray;
  selectedEnergyMeter ="1";
  parametersList;
  efficiency_g;
  chart_i;
  chart_e;
  allrequiredata;
  lengtho = 0;
  totalkwhcurrentmonth: any = 0;
  individual_graph_g;
  energyconsumption;
  KWHValue;
  averagepf;
  powerData;
  showInfo: string = 'first';
  animationRunning = true;
  animationRunnings = true;
  latestDate;
  meterCountValue;
  digits: number[];
  KWHValuer: any = 0;
  KWHValuel: any = 0;
  selectedTimeDuration = "Today";
  selectedParameter;
  meteridforParameters
  customDateRange;
  customeSelectedDate;
  data;
  latestkwh_p:any = 0;
  pf;
  current_l1;
  current_l2;
  current_l3;
  skVAh;
  graphDiv;
  Graphdata;
  dataSource;
  pfValue;
  allData;
  allDataMeter;
  lastUpdateDate;
  LiveAlertsArray =[];
  majorTicks = {
    interval: 10,
    color: 'red',
    height: 10,
    width: 3,
    position: 'Inside',
    offset: 5
  };
  minorTicks = {
    interval: 5,
    color: 'green',
    height: 5,
    width: 2,
    position: 'Inside',
    offset: 5
  };
  labelStyles = {
    position: 'Inside',
    format: '{value}',
    offset: 4,
    color: 'red',
    width: 2
  };
  cap = {
    radius: 5,
    border: {
      color: 'red',
      width: 3
    }
  };
  heading: any = [];
  blinkState = 'visible';
  timeOptions: any = ['Today', 'Yesterday', 'This Week', 'This Month', 'Last Month', 'Custom'];



  speakerOn: boolean = true;
  muteSuggestions: boolean = false;

  toggleSpeaker() {
    this.speakerOn = !this.speakerOn;
    this.muteSuggestions = !this.speakerOn;
  }

  getAlertClass(type: string): string {
    return type === 'Overload' ? 'alert-error' : 'alert-warning';
  }

  getAlertMessage(type: string): string {
    let message = type;
     message = message.substring(2);
     return message =  `Parameter: ${message}` ;
  
  }

  getAlertValue(type: string, actual: string): string {
    return type === 'Overload' ? `Actual Value: ${type}A` : `Actual Value: ${actual}`;
  
  }

  stopAnimations(): void {
    this.animationRunnings = false;
    const alertsLists = document.getElementById('suggestion-list');
    if (alertsLists) {
      alertsLists.classList.remove('suggestionlists');
    }
  }

  startAnimations(): void {
    this.animationRunnings = true;
    const alertsLists = document.getElementById('suggestion-list');
    if (alertsLists) {
      alertsLists.classList.add('suggestionlists');
          }
  }

  ngAfterViewInit() {
    this.graphDiv = this.chart;
    this.energyconsumption = this.energyconsumption_graph;

    this.individual_graph_g = this.individual_graph;
  }

  constructor(private datePipe: DatePipe ,private ngxLoader: NgxUiLoaderService, private deviceManagerSer: DeviceMasterService, private transMngSer: TransformerManagerService, private matDialog: MatDialog, private EmsdashboardService: EmsdashboardService) { }

  ngOnInit() {
    this.blink();
    this.getDeiceIds();
    this.graphIndividual();
   
 
  }
  getDeiceIds() {
    this.deviceManagerSer.getEMSDeviceId(JSON.parse(localStorage.getItem('userData')).userid).subscribe((response: any) => {
      if (response.result.length > 0) {

        let Deviceids = []
        response.result.forEach(function (value) {
          Deviceids.push(value.deviceId + "(" + value.sitename + ")");
        });
        this.Deviceid = Deviceids[0]
        this.uniqueDeviceId = Deviceids;
        console.log("?????????????????",this.uniqueDeviceId)
        this.selectedDevice = Deviceids[0];
        this.getselectedDeviceIddata(Deviceids[0]);


      }
    });
  }

  getselectedDeviceIddata(deviceid) {
    this.selectedDevice = deviceid;
    deviceid = deviceid.split('(')[0];
    this.transMngSer.getEnergyMeters(deviceid).toPromise().then((response1: any) => {
      if (response1.result.length > 0) {
        let energyMeterId = [];
        response1.result.forEach(function (value) {
          energyMeterId.push(value.meterSerialNumber + "(" + value.assetName + ")");
        });
       this.energyMeterIdArray = energyMeterId;
console.log("this.energyMeterIdArray",this.energyMeterIdArray)
this.meterCountValue = this.energyMeterIdArray.length;
        this.selectedEnergyMeter = energyMeterId[0];
        this.lastmeter = this.selectedEnergyMeter;
        this.EmsdashboardService.getParameterConfig(this.selectedEnergyMeter.split('(')[0]).toPromise().then((response1: any) => {
          if (response1.result.length > 0) {
            let Parameters = response1.result[0];
            delete Parameters['deletedflag'];
            delete Parameters['id'];
            delete Parameters['energyMeterId'];
       
            let paramKeys = []
            for (let keys in Parameters) {
               if (Parameters[keys] == 1) {
                paramKeys.push(keys)
              }
            }
            this.parametersList = paramKeys;
            this.selectedParameter = this.parametersList[0];
            this.selectedTimeDuration = this.timeOptions[0];
            this.getSelectedMeterDetail();
            this.updateMeterSelectData();
          }
        });
        
      } 
    });
  }
  graphIndividual(){
    const options = {
      series: [{
        name: "Value",
        data: [0]
      }],
      chart: {
        type: 'area',
        height: "100%",
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth'
      },
      title: {
        text: 'Individual Meter Graph Data',
        style: {
              color: "black",
              fontWeight: 'bold'
            },
        align: 'left',
       
      },
      xaxis: {
        type: 'DateTime',
        tickAmount: 2.2,
        tickPlacement: 'between',
        intervalType: 'Hours',
        labels: {
          show: true,
          style: {
            colors: 'black',
            fontWeight: 'bold'
          },
          rotate: 0,
        }
  
      },
      yaxis: {
        labels: {
          style: {
            colors: 'black'
          }
        }
      },
      legend: {
        horizontalAlign: 'left'
      }
    };
    this.chart_i = new ApexCharts(this.individual_graph.nativeElement, options);
    this.chart_i.render();
   }
  
  getSelectedMeterDetail(){
    console.log("this.selectedEnergyMeter",this.selectedEnergyMeter)
    console.log("this.selectedEnergyMeter split",this.selectedEnergyMeter.split('(')[0])
    this.EmsdashboardService.getemsmonthdata({ "meterid": [this.selectedEnergyMeter.split('(')[0]] }).subscribe(async (response: any) => {
   console.log("response from getemsmonthdata",response)
   let count=Number(response.data[0].count);
   let avgpfm = 0;

  if (response.data[0].avgpf && count > 0) {
     avgpfm = Number(response.data[0].avgpf / count);
   }    
   this.latestkwh_p = Number(response.data[0].kwh).toFixed(2); 
        this.pf = Number(avgpfm).toFixed(2);
        this.skVAh = Number(response.data[0].kvah).toFixed(2);
        this.totalkwhcurrentmonth = Number(response.data[0].logsystemkwh).toFixed(2);
    });

 
    this.updateMeterSelectData();
    this.getAlertDataBySelectedMeterId();
  }
updateMeterSelectData(){
  this.ngxLoader.startLoader('individual_graph');
  if(this.selectedTimeDuration == "Custom")
  {
    const dialogConfig = new MatDialogConfig();
    let dialogRef = this.matDialog.open(CustomDateComponent, {
      autoFocus: false,
      height: '350px', width: '450px', data: { "details": "", "action": "Add", selectedDate: this.customDateRange }
    });
    dialogRef.afterClosed().subscribe(value => {
      let startdate = value.startDate;
      let enddate = value.endDate;
      this.transMngSer.getEnergyMeterReportData({
        "meterid": this.selectedEnergyMeter.split('(')[0],
        "duration":this.selectedTimeDuration,
        "deviceid": this.selectedDevice.split('(')[0],
        "range":{"startDate":startdate,"endDate":enddate}
        }).toPromise().then((response: any) => {
          this.count_m =1;
          this.lastfives =response;
          this.lastfive();
           this.allDataMeter = this.sampleData(response.result, 3);
          this.updateGraphData();
        });
     
    });
  }else
  {
  
  this.transMngSer.getEnergyMeterReportData({
    "meterid": this.selectedEnergyMeter.split('(')[0],
    "duration":this.selectedTimeDuration,
    "deviceid": this.selectedDevice.split('(')[0],
    "range": this.customDateRange
    }).toPromise().then((response: any) => {
      if(response.result.length > 0){
      this.count_m =1;
      this.lastfives =response;
      this.lastfive();
       this.allDataMeter = this.sampleData(response.result, 3);
      this.updateGraphData();
      } else {
        this.allDataMeter = this.sampleData(response.result, 3);
        this.updateGraphData();
        this.ngxLoader.stopLoader('individual_graph');

      }
    });
  }
}

  updateGraphData(){
    let graphDataUpdate = this.allDataMeter.map((result) => ({
      x: result.DATE,
      y: result[this.selectedParameter],
    }));
    this.chart_i.updateSeries([{
      data: graphDataUpdate
    }]);
    this.ngxLoader.stopLoader('individual_graph');
  }

  getAlertDataBySelectedMeterId(){
    this.EmsdashboardService.getIndividualEnergyMeterAlerts({"meterId":this.selectedEnergyMeter.split('(')[0]}).toPromise().then((response1: any) => {
      if(response1.result.length > 0){
        this.LiveAlertsArray = response1.result;
      } else {
        this.LiveAlertsArray = [];
      }
      console.log("?????????????????",this.LiveAlertsArray)
    });
  }
  lastfive() {  
   
    let response=this.lastfives;
    if (this.count_m <= 5 ) {
           this.countstepno=this.count_m;
      const lastValue = response.result[response.result.length - this.count_m];
      
      this.current_l1 = lastValue.l1;
      this.current_l2 = lastValue.l2;
      this.current_l3 = lastValue.l3;
      this.lastUpdateDate = lastValue.DATE; 
 this.count_m ++; 
    
    }
    else{

      this.count_m = 1;
      this.countstepno=this.count_m;
      const lastValue = response.result[response.result.length - this.count_m];
      
      this.current_l1 = lastValue.l1;
      this.current_l2 = lastValue.l2;
      this.current_l3 = lastValue.l3;
      this.lastUpdateDate = lastValue.DATE;
      this.count_m ++; 
    }
  }
/* ######################################################*/

 
  // Sample data points by selecting every nth point
  sampleData(data, sampleSize) {
    if(this.selectedTimeDuration == "Last Month" ||  this.selectedTimeDuration =="This Month" || this.selectedTimeDuration == "This Week"){
      sampleSize = 15;
    }
    const sampledData = [];
    for (let i = 0; i < data.length; i += sampleSize) {
      sampledData.push(data[i]);
    }
    return sampledData;
  }
  incrementkwh(){
    if(this.showInfo === "first"){
      this.showInfo='fourth';
    }else{
      if(this.showInfo === "fourth")
      {
        this.showInfo='third';
      }
      else{
        if(this.showInfo === "third")
        {
          this.showInfo='second';
        }else{
          this.showInfo='first';
        }
      }
     
    }
  }
 
  resetkwhreset(){
    this.showInfo='first';
    this.totalkwhcurrentmonth =  this.totalkwhcurrentmonth;
    this.pf = this.pf;
    this.latestkwh_p=this.latestkwh_p
  }

  showcurrent(){
   
    if(this.showInfo === "first"){
      this.showInfo='second';
    }else{
      if(this.showInfo === "second")
      {
        this.showInfo='third';
      }
      else{
        if(this.showInfo === "third")
        {
          this.showInfo='fourth';
        }else{
          this.showInfo='first';
        }
      }
     
    }
  }
  getPowerFactorHeading() {
    if (this.pf < 0.9) {
      return "Low Lagging Power Factor (PF < 0.9)";
    } else if (this.pf >= 1) {
      return "High Leading Power Factor (PF > 1 or close to 1)";
    } else {
      return "Power Factor is within an acceptable range.";
    }
  }

  getPowerFactorSuggestion() {
    if (this.pf < 0.9) {
      return `- Consider installing power factor correction capacitors to improve the power factor and reduce losses.
      - Balance the loads across all phases to achieve a more uniform power distribution.
      - Evaluate the possibility of using more efficient motors or transformers to improve power factor performance.
      - Identify and address any inefficient or faulty equipment that might be causing the low power factor.`;
    } else if (this.pf >= 1) {
      return `- If leading power factor correction capacitors are installed, consider reducing or removing them to avoid voltage instability.
      - Check the proper functioning of capacitors to ensure they are not causing the leading power factor.
      - Investigate and analyze any capacitive loads or equipment connected to the system that might be contributing to the leading power factor.`;
    } else {
      return "Power Factor is within an acceptable range.";
    }
  }
  blink() {
    this.blinkState = 'hidden';
    setTimeout(() => {
      this.blinkState = 'visible';
      this.blink();
    }, 500);
  }
}
